module.exports = __webpack_public_path__ + "img/Line-Small.240f8822.svg";